import React, { useEffect, useState } from "react";
import IconDeltete from "../../assets/images/icon-delete.png";
import { uploadFiles } from "api/postApi";
import { toast } from "react-toastify";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { t } from "i18next";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, UploadProps } from "antd";
import { Spinner } from "reactstrap";

const props: UploadProps = {
  name: "files",
  accept: "video/mp4,video/x-m4v,video/*,image/png,image/jpeg,image/*",
  beforeUpload: () => false,
  headers: {
    authorization: "authorization-text",
  },
};

const UploadImageSingle = ({
  data,
  setLinkImage,
  formik,
  isMultiple = true,
  uploadProps,
  formikNameImage = "files",
  isPage,
  isDisabled = false
}: any) => {
  const [isLoadingUploadImage, setIsLoadingUploadImage] = useState<boolean>(false);
  const [urlImage, setURLImage] = useState<string>("");

  useEffect(() => {
    if (data) {
      const urlImage = data.includes(process.env.REACT_APP_UPLOAD_URL) ? data : `${(process.env.REACT_APP_UPLOAD_URL || '') + '/'}${data}`;
      setURLImage(urlImage)
    }
  }, [data])

  return (
    <React.Fragment>
      <>
        {urlImage && (
          <div
            className="overflow-x-auto color-scrollbar-os scrollbar-feed-thumbnail"
            style={{
              display: "flex",
              gap: 10,
              marginBottom: 10,
              paddingTop: 20,
            }}
          >
            {
              <div
                style={{
                  position: "relative",
                }}
              >
                <img
                  alt="thumbnail"
                  src={urlImage}
                  style={{ maxHeight: 120, maxWidth: 160, cursor: "pointer" }}
                  onClick={() => {
                    setLinkImage && setLinkImage(isPage === 'bar' ? { url: urlImage } : urlImage);
                  }}
                />
                {
                  !isDisabled && (
                    <span
                      onClick={() => {
                        formik.setFieldValue(formikNameImage, null);
                        setURLImage("");
                      }}
                      style={{
                        color: "red",
                        position: "absolute",
                        top: "-12px",
                        right: "-5px",
                        cursor: "pointer",
                      }}
                    >
                      <img src={IconDeltete} alt="delete" width={18} height={18} />
                    </span>
                  )
                }
              </div>
            }
          </div>
        )}
        <div>
          {isLoadingUploadImage && (
            <Spinner
              size="sm"
              className="me-2"
              style={{ color: "#4da3da" }}
            ></Spinner>
          )}
        </div>

        {!isDisabled &&
          (<div>
            <Upload
              {...(uploadProps ? uploadProps : props)}
              multiple={isMultiple}
              beforeUpload={() => false}
              fileList={[]}
              onChange={async (info: any) => {
                setIsLoadingUploadImage(true);
                try {
                  const files = info.fileList;
                  const data = new FormData();
                  for (var i = 0; i < files?.length; i++) {
                    data.append("files", files[i]?.originFileObj);
                  }

                  const res = (await uploadFiles(data)) as any;
                  if (res?.code === 200) {
                    setIsLoadingUploadImage(false);

                    formik.setFieldValue(
                      formikNameImage,
                      res?.data?.[0]?.filepath
                    );
                  } else {
                    setIsLoadingUploadImage(false);
                  }
                } catch (error: any) {
                  setIsLoadingUploadImage(false);
                  toast(
                    `${t("Input buffer contains unsupported image format")}`,
                    CONFIG_OPTION_TOAST_ERROR
                  );
                }
              }}
              onRemove={() => {
                //return onGalleryFileRemove();
              }}
            >
              <Button icon={<UploadOutlined />}>{t("Click to Upload")}</Button>
            </Upload>
            {formik.touched?.[formikNameImage] &&
              formik?.errors?.[formikNameImage] ? (
              <div className="text-danger mt-2">
                {formik?.errors?.[formikNameImage]}
              </div>
            ) : null}
          </div>)
        }
      </>
    </React.Fragment>
  );
};

export default UploadImageSingle;
